import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { Box, Divider, Typography } from '@mui/material'

import DeliveryAPI from '../../api/orbitV1/DeliveryAPI'
import OrderAPI from '../../api/orbitV1/OrderAPI'
import profilePlaceholder from '../../assets/placeholders/profile_placeholder.png' // Profile picture placeholder
import PageLayout from '../../common/Layout/Page/PageLayout'
import { ColorBoxContent, PictureWrapper } from '../../common/ui/colorBox'
import OrbitSession from '../../hooks/useCookies'

function DeliveryDetail() {
  const { orderNo } = useParams()
  const [order, setOrder] = useState({})
  const [delivery, setDelivery] = useState({})
  const [items, setItems] = useState([])
  const [profilePic, setProfilePic] = useState(profilePlaceholder)

  const getOrder = async (_orderNo) => {
    try {
      const orderStatus = await OrderAPI.getOrderStatus(_orderNo)
      if (orderStatus && orderStatus.data) {
        setOrder(orderStatus.data)
        setItems(orderStatus.data.items)
      }
    } catch (error) {
      toast.error(error.response.message)
    }
  }

  const getDelivery = async (_orderNo) => {
    try {
      const deliveryDetails = await DeliveryAPI.getDelivery(_orderNo)
      if (deliveryDetails && deliveryDetails.data) {
        setDelivery(deliveryDetails.data)
      }
    } catch (error) {
      toast.error(error.response.message)
    }
  }

  useEffect(() => {
    getOrder(orderNo)
    getDelivery(orderNo)
    const profileImgUrl = OrbitSession.get('profileImg')
    profileImgUrl
      ? setProfilePic(profileImgUrl)
      : setProfilePic(profilePlaceholder)
  }, [])

  return (
    <PageLayout header='View Delivery'>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          padding: '32px 0'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-start',
            gap: '2%',
            width: '100%'
          }}
        >
          <Box
            sx={{
              width: '60%',
              backgroundColor: '#FFFFFF'
            }}
          >
            <Box>
              <ColorBoxContent
                variant='primary'
                display='flex'
                justifyContent='space-between'
                alignItems='center'
              >
                <Typography variant='h4'>Delivery Items</Typography>
                <Typography sx={{ fontSize: '14px', color: '#818D9C' }}>
                  Order No.: {order.orderNo}
                </Typography>
                <table style={{ width: '100%' }}>
                  <tr>
                    <th align='left'>{delivery.deliveryDate}</th>
                    <th align='right'>
                      {`${delivery.deliveryStartTime} - ${delivery.deliveryEndTime}`}
                    </th>
                  </tr>
                </table>

                <Divider variant='fullWidth' />
                <table style={{ width: '100%' }}>
                  <tr>
                    <th align='left'>Order Summary</th>
                    <th align='right'>Quantity</th>
                  </tr>
                  <tr>
                    <td colSpan='2'>
                      <Divider variant='fullWidth' />
                    </td>
                  </tr>
                  {items.map((p, index) => (
                    <tr key={index}>
                      <td align='left'>
                        {p.name}
                        <br />
                        <Typography sx={{ fontSize: '14px', color: '#818D9C' }}>
                          {`${p.data} GB, ${p.voice}mins talktime, ${p.sms} SMS`}
                        </Typography>
                      </td>
                      <td align='right'>{p.quantity}</td>
                    </tr>
                  ))}
                </table>
              </ColorBoxContent>
            </Box>
          </Box>
          <Box sx={{ width: '40%', justifyContent: 'center' }}>
            <Box>
              <ColorBoxContent
                variant='primary'
                display='flex'
                justifyContent='space-between'
                alignItems='center'
              >
                <PictureWrapper
                  style={{
                    width: '200px',
                    height: '200px',
                    borderRadius: '100px',
                    align: 'center'
                  }}
                  image={profilePic}
                />
                <table>
                  <tr align='left'>
                    <th>
                      <Typography variant='h4'>
                        {delivery.contactName}
                      </Typography>
                    </th>
                  </tr>
                  <tr align='left'>
                    <th>
                      <Typography sx={{ fontSize: '14px', color: '#818D9C' }}>
                        Contact Number
                      </Typography>
                    </th>
                  </tr>
                  <tr align='left'>
                    <th>
                      <Typography>+65{delivery.contactNumber}</Typography>
                    </th>
                  </tr>

                  <tr align='left'>
                    <th>
                      <Typography sx={{ fontSize: '14px', color: '#818D9C' }}>
                        Delivery Address
                      </Typography>
                    </th>
                  </tr>
                  <tr>
                    <td>{delivery.address + ', ' + delivery.postalCode}</td>
                  </tr>
                </table>
              </ColorBoxContent>
            </Box>
          </Box>
        </Box>
      </Box>
    </PageLayout>
  )
}

export default DeliveryDetail
